<template>
    <v-checkbox
        ref="filterFromDoc"
        v-model="filterDoc"
        :readonly="disableElementsReq"
        label="Filter Doctors by Specialization"
        @change="handleChangeFilterDoc($event)"
    />
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['req', 'disableElementsReq'],
    data: ()=>({
        filterDoc: null
    }),
    watch: {
        'req.filter.doc'(newVal) {
            this.filterDoc = newVal
        }
    },
    methods: {
        ...mapActions(['reqDoctors']),
        handleChangeFilterDoc(value) {
            this.req.filter.doc = value
            if (!value) this.req.specField = { sp_name: 'ALL', sp_desc: '' }
            this.req.hospClinType = 'H'
            this.req.decking = ''
            if (this.req.facility && !value) {
                this.req.hospClinDoctor = ''
                this.req.hospClinType = 'H'
                this.req.hospClinDoctorCode = null
                this.reqDoctors({ PTYPE: '', HOSP_MSU: this.req.facility && this.req.facility.hosp_msu_code, SPEC: this.req.specField && this.req.specField.sp_desc })
            }
        }
    }
}
</script>
